import { FC } from "react";
import { Outlet, useSearchParams } from "react-router-dom";
import { useLocation } from "react-router";
import { Box } from "@mui/material";

import { useAsu } from "@framework/provider-asu";

import { Header } from "../header";
import { MainMenu, getActiveDrawerWidth } from "../main-menu";
import { MultiAnalysisProvider } from "../../../context/multi-analysis-context";
import { StyledContainer, StyledRoot } from "./styled";

export const Layout: FC = () => {
  const { isMenuOpen, tab } = useAsu();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const isDashboard = location.pathname.startsWith("/dashboard");
  const isProfile = location.pathname.startsWith("/profile");
  const menuDrawerWidth = getActiveDrawerWidth(tab);

  const onlyPage = searchParams.get("onlyPage") === "true";

  return (
    <MultiAnalysisProvider>
      <StyledRoot>
        <Box sx={{ display: onlyPage ? "none" : "inherit" }}>
          <Header />
          <MainMenu />
        </Box>
        <StyledContainer
          isDashboard={isDashboard}
          isProfile={isProfile}
          isMenuOpen={isMenuOpen}
          onlyPage={onlyPage}
          menuDrawerWidth={menuDrawerWidth}
          maxWidth={onlyPage || isDashboard || isProfile ? false : "md"}
        >
          <Outlet />
        </StyledContainer>
      </StyledRoot>
    </MultiAnalysisProvider>
  );
};
